var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDdqEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0023 9.66513L12.3349 3.99631M1 19.1104V16.1067C1.00278 15.6114 1.19978 15.1356 1.54802 14.7846L14.7725 1.56008C14.948 1.38265 15.1569 1.24178 15.3872 1.14564C15.6175 1.0495 15.8645 1 16.1141 1C16.3636 1 16.6107 1.0495 16.841 1.14564C17.0713 1.24178 17.2802 1.38265 17.4557 1.56008L20.4399 4.54433C20.6174 4.7198 20.7582 4.92873 20.8544 5.15902C20.9505 5.3893 21 5.63637 21 5.88592C21 6.13547 20.9505 6.38254 20.8544 6.61283C20.7582 6.84311 20.6174 7.05204 20.4399 7.22751L7.21545 20.452C6.8638 20.8012 6.38887 20.9981 5.89328 21H2.88961C2.64136 21.0004 2.39548 20.9517 2.16606 20.8569C1.93663 20.7621 1.72818 20.6229 1.55264 20.4474C1.3771 20.2718 1.23793 20.0634 1.1431 19.8339C1.04826 19.6045 0.999637 19.3586 1 19.1104Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdqEdit);
export default __webpack_public_path__ + "static/media/ddq-edit.ab74bb802736a1d5a7e1073a289ecfd5.svg";
export { ForwardRef as ReactComponent };